export const image_backend_url = "http://localhost:8080/api/products/image/";
